import React, { createContext, useState, useContext } from 'react';

const FontContext = createContext();

export function FontProvider({ children }) {
  const [fontType, setFontType] = useState('sans-serif');

  const fontClass = fontType === 'ortho' ? 'ortho-font' : '';

  return (
    <FontContext.Provider value={{ fontType, setFontType }}>
      <div className={fontClass}>
        {children}
      </div>
    </FontContext.Provider>
  );
}

export function useFont() {
  return useContext(FontContext);
}
